export default class InvalidUrl extends Error {
  constructor(url) {
    super(`"${url}" is not an easily recognizable absolute URL`);
  }
}
